
import { computed, defineComponent } from "vue";
import { useRouter } from "vue-router";
import { routeNames } from "@/router/index";
import { ITemplateSet, consts, IAttribute } from "@/services/Models";
import MiddleHeader from "@/components/MiddleHeader.vue";
import HorizontalList from "@/components/HorizontalList.vue";
import Thumbnail, { ThumbnailItem } from "@/components/Thumbnail.vue";
import TemplateThumbnail from "@/components/TemplateThumbnail.vue";
import FilterAttribute from "@/components/FilterAttribute.vue";
import store from "@/stores";
import { shuffle, toResourceUrl } from "@/lib/shared";

export default defineComponent({
  name: "SelectTemplate",
  components: {
    HorizontalList,
    MiddleHeader,
    FilterAttribute,
    Thumbnail,
    TemplateThumbnail,
  },
  setup() {
    const resource = store.useResource();
    const router = useRouter();

    // 作者を水平リスト用モデルに変換
    const authorListItems = computed(() => {
      return resource.data.campaigns.map((x) => ({
        imgPath: toResourceUrl(x.bunnerPath),
        clickAction: () =>
          router.push({
            name: routeNames.SearchTemplate,
            params: { campaignID: x.id },
          }),
      }));
    });

    // 属性でテンプレートをカテゴライズして水平リスト用モデルに変換
    const attributeTemplateSet = computed(() => {
      const templates = resource.data.templateSets.filter((x) =>
        x.frames.some((frame) => frame.author.isFamous == false) && x.deleteFlg == false
      );
      if (templates === undefined) return [];
      const viewGroup = resource.data.attributeGroups.find(
        (x) => x.id === consts.touchAttrGroupID
      );
      if (viewGroup === undefined) return [];
      return new Map(
        viewGroup.attributes.map((a) => [
          a.name,
          [
            "全部見る",
            () =>
              router.push({
                name: routeNames.SearchTemplate,
                query: { attributeID: a.id },
              }),
            shuffle(templates.filter((x) => x.tags.some((t) => t.id == a.id))),
          ],
        ])
      );
    });

    // カルーセルの作者はシステム
    const carousel = resource.data.templateSets.find((x) =>
      x.frames.some((frame) => frame.author.id == consts.systemAuthor)
    );
    const toEditCarousel = () => {
      router.push({
        name: routeNames.EditTemplate,
        params: {
          templateID: carousel?.id ?? "",
        },
      });
    };
    const emptyItem = ThumbnailItem.Empty();
    const emptyTemplate: ITemplateSet = {
      id: -1,
      describe: "",
      frames: [],
      thumbnail: "",
      tags: [],
      deleteFlg: false,
    };

    return {
      ...resource.data,
      authorListItems,
      attributeTemplateSet,
      emptyItem,
      emptyTemplate,
      toEditCarousel,
    };
  },
});
